"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaInputControl = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any, react/jsx-no-bind */
var address_ui_1 = require("@newfront-insurance/address-ui");
var core_1 = require("@newfront-insurance/core");
var core_money_1 = require("@newfront-insurance/core-money");
var core_ui_1 = require("@newfront-insurance/core-ui");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var ajv_1 = __importDefault(require("ajv"));
var formik_1 = require("formik");
var get_1 = __importDefault(require("lodash/get"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var omit_1 = __importDefault(require("lodash/omit"));
var trimStart_1 = __importDefault(require("lodash/trimStart"));
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line import/no-cycle
var address_or_state_1 = require("../components/address-or-state");
var currencywithnumber_1 = require("../components/currencywithnumber");
var date_field_1 = require("../components/date-field");
var percentage_input_1 = require("../components/percentage-input");
var context_1 = require("../context");
var registry_1 = require("./registry");
var ajv = new ajv_1.default({
    strict: false,
    allErrors: true,
    $data: true,
    strictTypes: false,
    logger: false,
    messages: true,
});
function SchemaInputControl(props) {
    var name = props.name, type = props.type, metadata = props.metadata, schema = props.schema, fieldPath = props.fieldPath;
    var context = (0, formik_1.useFormikContext)();
    var _a = context || {}, values = _a.values, initialValues = _a.initialValues;
    var rootSchema = (0, context_1.useRootSchema)();
    var accountUuid = (0, context_1.useSchemaAccountUuid)();
    var fieldName = name + "." + fieldPath;
    var initialValue = (0, get_1.default)(initialValues, fieldName);
    var _b = (0, formik_1.useField)({
        name: fieldName,
        // field validation is the most complex function of this package due to how json-schemas are validated
        // if it's a nested schema, the validator doesn't tell which nested fields are invalid, it only tells that the field is missing
        // TODO: move this validation to the form-level as it is not per-field but per-form
        // also, run the validator over each nested schema so that we can catch nested field errors upfront to improve the UX
        validate: function (value) {
            var validator = ajv.compile(rootSchema);
            validator((0, get_1.default)(values, name));
            var jsonSchemaError = (validator.errors || []).find(function (error) {
                var flatErrorKey = (0, trimStart_1.default)(error.instancePath, '/');
                if (flatErrorKey === fieldPath) {
                    return error;
                }
                if (error.params.missingProperty) {
                    // json schema errors are separated by "/" (/name/firstName), so we just replace it by "." and make them compatible with our field paths
                    var errorKey = (0, trimStart_1.default)(error.instancePath.replaceAll('/', '.') + "." + error.params.missingProperty, '.');
                    var splittedErrorKey = errorKey.split('.');
                    var splittedFieldPath = fieldPath.split('.');
                    // nesting is separated by dots, so the error should be shown if it's field nesting is only one level deeper than the error nesting
                    if (splittedFieldPath.length > splittedErrorKey.length + 1) {
                        return false;
                    }
                    if (errorKey === fieldPath || splittedFieldPath[0] === errorKey || fieldPath.startsWith(errorKey)) {
                        return error;
                    }
                }
                else {
                    if (error.keyword === 'if') {
                        return false;
                    }
                    var errorKey = (0, trimStart_1.default)("" + error.instancePath.replaceAll('/', '.'), '.');
                    if (errorKey === fieldPath || fieldPath.startsWith(errorKey) || errorKey.startsWith(fieldPath)) {
                        return error;
                    }
                }
                return false;
            });
            if (jsonSchemaError) {
                return ((schema.errors || {})[jsonSchemaError.keyword] ||
                    (jsonSchemaError.keyword === 'required' ? 'This field is required' : 'This field is invalid'));
            }
            return undefined;
        },
    }), input = _b[0], setValue = _b[2].setValue;
    var value = input.value;
    function onChange(newValue) {
        if (typeof newValue === 'string' && (0, isEmpty_1.default)(newValue)) {
            setValue(undefined);
        }
        else {
            setValue(newValue, false);
        }
        // skipping validation due to race conditions on how formik validation works
        // we wait the next tick and call the validation manually to avoid weird UI validation errors
        setTimeout(function () {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            context.validateForm();
        }, 0);
    }
    switch (type) {
        case dsl_schema_api_1.InputType.CHECKBOX:
            return (react_1.default.createElement(core_ui_1.CheckboxRow, { label: (metadata === null || metadata === void 0 ? void 0 : metadata.checkboxLabel) || '', isActive: value, onClick: onChange, style: { minHeight: 40, alignItems: 'center' } }));
        case dsl_schema_api_1.InputType.RADIO:
            return react_1.default.createElement(core_ui_1.RadioButtonGroup, { name: name, value: value, options: (metadata === null || metadata === void 0 ? void 0 : metadata.options) || [], onChange: onChange });
        case dsl_schema_api_1.InputType.NUMBER:
            return (react_1.default.createElement(core_ui_1.Input, { type: "number", value: value || parseInt(value, 10) === 0 ? value : '', onChange: function (inputValue) { return onChange(inputValue ? Number(inputValue) : undefined); }, appendText: metadata === null || metadata === void 0 ? void 0 : metadata.appendText }));
        case dsl_schema_api_1.InputType.CURRENCY: {
            var decimalScale = (metadata === null || metadata === void 0 ? void 0 : metadata.allowCents) ? undefined : 0;
            return (react_1.default.createElement(core_ui_1.CurrencyInput, { name: name, value: (0, core_money_1.toNumberOrUndefinedFromMoney)(value), decimalScale: decimalScale, onChange: function (inputValue) { return onChange(inputValue !== undefined ? (0, core_money_1.toMoney)(inputValue) : undefined); } }));
        }
        case dsl_schema_api_1.InputType.CURRENCY_APPLIES: {
            var decimalScale = (metadata === null || metadata === void 0 ? void 0 : metadata.allowCents) ? undefined : 0;
            return (react_1.default.createElement(core_ui_1.CurrencyInput, { name: name, value: (0, core_money_1.toNumberOrUndefinedFromMoney)(value === null || value === void 0 ? void 0 : value.money), decimalScale: decimalScale, onChange: function (inputValue) {
                    return onChange(inputValue !== undefined ? { money: (0, core_money_1.toMoney)(inputValue), applies: !!inputValue } : undefined);
                } }));
        }
        case dsl_schema_api_1.InputType.CURRENCY_PERCENTAGE: {
            var _c = metadata || {}, options = _c.options, allowCents = _c.allowCents, currencyEnabledOptions_1 = _c.currencyEnabledOptions, percentageEnabledOptions_1 = _c.percentageEnabledOptions;
            if (!metadata || !options)
                return react_1.default.createElement(react_1.default.Fragment, null);
            var decimalScale = allowCents ? undefined : 0;
            var currencyEnabled = currencyEnabledOptions_1 === null || currencyEnabledOptions_1 === void 0 ? void 0 : currencyEnabledOptions_1.includes(value === null || value === void 0 ? void 0 : value.type);
            var percentageEnabled = percentageEnabledOptions_1 === null || percentageEnabledOptions_1 === void 0 ? void 0 : percentageEnabledOptions_1.includes(value === null || value === void 0 ? void 0 : value.type);
            return (react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: "row" },
                react_1.default.createElement(core_ui_1.SelectInput, { name: name, options: options || [], value: value === null || value === void 0 ? void 0 : value.type, onChange: function (newType) {
                        var newValue = { type: newType, money: undefined, percentage: undefined };
                        if (currencyEnabledOptions_1 === null || currencyEnabledOptions_1 === void 0 ? void 0 : currencyEnabledOptions_1.includes(newType))
                            newValue.money = value === null || value === void 0 ? void 0 : value.money;
                        else if (percentageEnabledOptions_1 === null || percentageEnabledOptions_1 === void 0 ? void 0 : percentageEnabledOptions_1.includes(newType))
                            newValue.percentage = value === null || value === void 0 ? void 0 : value.percentage;
                        onChange(newValue);
                    }, showSelectAnOption: true }),
                currencyEnabled && (react_1.default.createElement(core_ui_1.CurrencyInput, { name: name, value: (0, core_money_1.toNumberOrUndefinedFromMoney)(value === null || value === void 0 ? void 0 : value.money), decimalScale: decimalScale, onChange: function (inputValue) {
                        return onChange(inputValue !== undefined ? { type: value === null || value === void 0 ? void 0 : value.type, money: (0, core_money_1.toMoney)(inputValue) } : { type: value === null || value === void 0 ? void 0 : value.type });
                    } })),
                percentageEnabled && (react_1.default.createElement(core_ui_1.Input, { type: "number", value: value === null || value === void 0 ? void 0 : value.percentage, onChange: function (inputValue) {
                        return onChange(inputValue
                            ? { type: value === null || value === void 0 ? void 0 : value.type, percentage: Number(inputValue) }
                            : { type: value === null || value === void 0 ? void 0 : value.type, percentage: undefined });
                    }, appendText: "%" }))));
        }
        case dsl_schema_api_1.InputType.CURRENCY_WITH_NUMBER: {
            var _d = metadata || {}, numberFieldName = _d.numberFieldName, currencyFieldName = _d.currencyFieldName, numberFieldLabel = _d.numberFieldLabel, currencyFieldLabel = _d.currencyFieldLabel, allowCents = _d.allowCents;
            if (!metadata || !numberFieldName || !currencyFieldName)
                return react_1.default.createElement(react_1.default.Fragment, null);
            var decimalScale = allowCents ? undefined : 0;
            return (react_1.default.createElement(currencywithnumber_1.CurrencyWithNumber, { name: name, value: value, onChange: onChange, currencyFieldLabel: currencyFieldLabel, currencyFieldName: currencyFieldName, numberFieldLabel: numberFieldLabel, numberFieldName: numberFieldName, decimalScale: decimalScale, appendText: metadata === null || metadata === void 0 ? void 0 : metadata.appendText }));
        }
        case dsl_schema_api_1.InputType.CURRENCY_WITH_TYPE: {
            var _e = metadata || {}, options = _e.options, currencyEnabledOptions_2 = _e.currencyEnabledOptions, allowCents = _e.allowCents;
            if (!metadata || !options || !currencyEnabledOptions_2)
                return react_1.default.createElement(react_1.default.Fragment, null);
            var decimalScale = allowCents ? undefined : 0;
            return (react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: "row" },
                react_1.default.createElement(core_ui_1.SelectInput, { name: name, options: options, value: value === null || value === void 0 ? void 0 : value.type, onChange: function (newType) {
                        var newValue = { type: newType, money: undefined };
                        if (currencyEnabledOptions_2.includes(newType))
                            newValue.money = value === null || value === void 0 ? void 0 : value.money;
                        onChange(newValue);
                    }, showSelectAnOption: true }),
                react_1.default.createElement(core_ui_1.CurrencyInput, { name: name, value: (0, core_money_1.toNumberOrUndefinedFromMoney)(value === null || value === void 0 ? void 0 : value.money), decimalScale: decimalScale, onChange: function (inputValue) {
                        return onChange(inputValue !== undefined ? __assign(__assign({}, value), { money: (0, core_money_1.toMoney)(inputValue) }) : undefined);
                    }, disabled: !currencyEnabledOptions_2.includes(value === null || value === void 0 ? void 0 : value.type) })));
        }
        case dsl_schema_api_1.InputType.DATE:
            return react_1.default.createElement(date_field_1.DateField, { name: name, initialValue: initialValue, setValue: setValue });
        case dsl_schema_api_1.InputType.SELECT:
            return (react_1.default.createElement(core_ui_1.SelectInput, { name: name, options: (metadata === null || metadata === void 0 ? void 0 : metadata.options) || [], value: value, onChange: onChange, showSelectAnOption: true, showSelectAnOptionDisabled: false }));
        case dsl_schema_api_1.InputType.MULTI_SELECT:
            return (react_1.default.createElement(core_ui_1.AdvancedSelectInput, { name: name, onChange: onChange, isMulti: true, options: (metadata === null || metadata === void 0 ? void 0 : metadata.options) || [], value: value }));
        case dsl_schema_api_1.InputType.TEXT: {
            if ((metadata === null || metadata === void 0 ? void 0 : metadata.textInputType) === dsl_schema_api_1.TextInputType.TEXT_AREA) {
                return react_1.default.createElement(core_ui_1.TextareaAutosize, { value: value, onChange: function (event) { return onChange(event.target.value); } });
            }
            return react_1.default.createElement(core_ui_1.Input, { type: "text", value: value, onChange: onChange });
        }
        case dsl_schema_api_1.InputType.PERCENTAGE: {
            return react_1.default.createElement(percentage_input_1.PercentageInput, { value: value, onChange: onChange });
        }
        case dsl_schema_api_1.InputType.ADDRESS: {
            // if accountUuid was not provided, we can't render the address selector
            if (!accountUuid) {
                return react_1.default.createElement(address_ui_1.AddressDisplayField, { address: value, width: "100%" });
            }
            return react_1.default.createElement(address_ui_1.AddressSelector, { accountUuid: accountUuid, onChange: onChange, selectedAddress: value, width: 400 });
        }
        case dsl_schema_api_1.InputType.ADDRESS_OR_STATE: {
            // if accountUuid was not provided, we can't render the address selector
            if (!accountUuid) {
                return react_1.default.createElement(address_ui_1.AddressDisplayField, { address: value, width: "100%" });
            }
            return react_1.default.createElement(address_or_state_1.AddressOrState, { value: value, onChange: onChange, schema: schema, fieldPath: fieldPath, name: name });
        }
        default: {
            // Check if there is a custom component for the type and use it if that is the case
            var CustomComponent = registry_1.customInputComponentsRegistry[type];
            if (CustomComponent) {
                // eslint-disable-next-line react/jsx-props-no-spreading
                return react_1.default.createElement(CustomComponent, __assign({}, (0, omit_1.default)(props, 'type'), { onChange: onChange, value: value }));
            }
            // fallback
            return react_1.default.createElement(core_ui_1.Input, { type: "text", value: value || '', onChange: onChange });
        }
    }
}
exports.SchemaInputControl = SchemaInputControl;
/**
 * Allows to extend SchemaInputControl by adding new inputType handlers
 * @param inputType
 * @param customInput
 */
SchemaInputControl.registerComponent = function (inputType, customInput) {
    var previouslyRegisteredComponent = registry_1.customInputComponentsRegistry[inputType];
    if ((0, core_1.isNotNil)(previouslyRegisteredComponent)) {
        // eslint-disable-next-line no-console
        console.warn("SchemaInputControl.registerComponent for type \"" + inputType + "\" override. It was already set.");
    }
    registry_1.customInputComponentsRegistry[inputType] = customInput;
};
